import React, { useState } from 'react';

import { get, isEmpty, map } from 'lodash';
import cx from 'classnames';

import { OptionType } from '@/kaya/Menu/menu.type';
import { Menu } from '@/kaya';

import styles from './table.module.scss';

interface Column {
  field: string;
  headerName: string;
  className?: string;
  isCheckbox?: boolean;
  isSort?: boolean;
  renderCell?: (row?: object) => React.ReactNode /*keyof JSX.IntrinsicElements*/;
}

interface Props<T> {
  children?: React.ReactNode;
  columns: Array<Column>;
  rows: Array<T>;
  getOptions?: (row: T) => Array<OptionType>;
  handleRowClick?: (row: T) => void;
  setHeaderCheckBox?: React.Dispatch<React.SetStateAction<number>>;
  headerCheckBox?: number;
  columnnStyle?: string;
  disableActions?: boolean;
}

const Table = <T extends object>(props: Props<T>) => {
  const {
    children,
    columns,
    rows,
    getOptions,
    handleRowClick,
    columnnStyle,
    disableActions = false,
  } = props;

  const [selectedRow, setSelectedRow] = useState({} as T);
  const [rowIndex, setRowIndex] = useState<number | null>(null);

  return (
    <div className={cx(styles.tableWrapper)}>
      <div className={cx(styles.column, columnnStyle)}>
        {map(columns, (column, index) => (
          <div className={cx(styles.header, column.className)} key={`column${index}`}>
            <p className={styles.headerName}>{column.headerName}</p>
          </div>
        ))}
        {!disableActions && <div className={cx(styles.c6)}></div>}
      </div>

      {!isEmpty(rows) ? (
        <div className={styles.rowsContainer}>
          {map(rows, (row, outerIndex) => (
            <div
              className={cx(styles.rows, {
                [styles.evenRows]: outerIndex % 2 === 1 ? true : false,
              })}
              key={`outerRow${outerIndex}`}
              onClick={() => {
                if (handleRowClick) {
                  handleRowClick(row);
                }
              }}
              onMouseEnter={() => {
                setRowIndex(outerIndex);
              }}
              onMouseLeave={() => {
                setRowIndex(null);
              }}
            >
              {map(columns, (column, index) => {
                if (column.renderCell) {
                  return (
                    <div className={cx(styles.c1, column.className)} key={`innerRow${index}`}>
                      {column.renderCell({
                        ...row,
                        // isChecked: isChecked,
                        // setIsChecked: setIsChecked,
                        index: outerIndex,
                        rowHover: rowIndex === outerIndex ? true : false,
                      })}
                    </div>
                  );
                } else {
                  return (
                    <div className={cx(styles.r1, column.className)} key={index}>
                      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                      {/* @ts-ignore */}
                      <p className={styles.p1}>{get(row, column.field, '-')}</p>
                    </div>
                  );
                }
              })}
              {!disableActions && (
                <div className={cx(styles.c6)}>
                  <Menu
                    width={'200px'}
                    options={getOptions && getOptions(selectedRow)}
                    placement="bottom"
                  >
                    <div
                      className={styles.icon}
                      onClick={() => {
                        setSelectedRow({ ...row, outerIndex });
                      }}
                    >
                      {/* <Icon type={iconsConstants.ICONS.MORE} /> */}
                    </div>
                  </Menu>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.noData}>No Data Found!!</p>
      )}
    </div>
  );
};

export default Table;
